const getAll = ({ module }) => (
  fetch(`${process.env.VUE_APP_API_URL}/module-material-type/${module}`, { credentials: 'include' })
    .then(response => {
      return response.text()
        .then(text => {
          if (!response.ok) {
            return Promise.reject(response.statusText)
          }
          const data = text && JSON.parse(text)
          return data
        })
    })
)

export default {
  getAll
}
